import React from 'react';
import Tooltip from './Tooltip';
import classNames from 'classnames';

export default function FormSection(props) {
  const {
    title,
    subtitle,
    tooltip,
    children,
    className,
    white = false
  } = props;

  return (
    <div className={className}>
      {(title || subtitle || tooltip) && (
        <div className="mb-3">
          <div className="flex items-center space-x-2">
            {title && (
              <div className={classNames(
                `text-xl font-semibold flex-1x`,
                white ? 'text-white' : 'text-cs-gray-900'
              )}>
                {title}
              </div>
            )}
            {title && tooltip && (
              <div>
                <Tooltip tooltip={tooltip} white={white} />
              </div>
            )}
          </div>
          {subtitle && (
            <div className="flex items-center space-x-2">
              <div className={classNames(
                'text-base flex-1x',
                white ? 'text-white' : 'text-cs-gray-500'
              )}>
                {subtitle}
              </div>
              {!title && tooltip && (
                <div>
                  <Tooltip tooltip={tooltip} subtitle={true} white={white} />
                </div>
              )}
            </div>
          )}
        </div>
      )}
      {children}
    </div>
  );
}
